import { LoadingIndicator } from '..';
import React from 'react';

export interface ImageWithFallbacksProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt' | 'onError' | 'onLoad' | 'onChange'>{
  fallbacks?: string;
  src: string;
  alt?: string;
  loader?: boolean;
}

type ImageWithFallbacksState = {
  src: string;
  fallbackIndex: number;
  fallbacks: string[];
  loaded: boolean;
};

class ImageWithFallbacks extends React.Component<ImageWithFallbacksProps, ImageWithFallbacksState> {
  constructor(props: ImageWithFallbacksProps) {
    super(props);
    this.state = {
      src: props.src,
      fallbackIndex: 0,
      fallbacks: this.props.fallbacks?.split('|') ?? [],
      loaded: false,
    };
  }
  componentDidUpdate(prevProps: ImageWithFallbacksProps) {
    if (prevProps.src !== this.props.src && prevProps.fallbacks !== this.props.fallbacks) {
      this.setState({
        src: this.props.src,
        fallbackIndex: 0,
        fallbacks: this.props.fallbacks?.split('|') ?? [],
        loaded: false,
      });
    }
  }
  onError() {
    if (this.state.fallbackIndex > this.state.fallbacks.length) {
      return;
    }
    this.setState({
      src: this.state.fallbacks[this.state.fallbackIndex],
      fallbackIndex: this.state.fallbackIndex + 1,
      fallbacks: this.state.fallbacks,
    });
  }
  onLoad() {
    this.setState({ ...this.state, loaded: true });
  }
  render() {
    const {src, alt, fallbacks, loader, loading, ...rest} = this.props;
    return (
      <>
        <img src={this.state.src}
             onError={() => this.onError()}
             onChange={() => this.onLoad()}
             onLoad={() => this.onLoad()}
             alt={this.props.alt}
             {...rest}/>
        {this.props.loader && !this.state.loaded && <LoadingIndicator id="imgWithFallbackLoadingIndicator"></LoadingIndicator>}
      </>
    );
  }
}

export default ImageWithFallbacks;
